import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArticleContentFormComponent } from './components/article-content-form/article-content-form.component';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { ArticleContentMergeConflictComponent } from './components/article-content-merge-conflict/article-content-merge-conflict.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      {
        path: 'new',
        component: ArticleContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.ARTICLE, true, '/#/content/create/0'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: ArticleContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.ARTICLE, true, '/#/content/:id'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id/edit',
        component: ArticleContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.ARTICLE, true, '/#/content/:id'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },

      {
        path: ':id/conflict',
        component: ArticleContentMergeConflictComponent,
        canActivate: [
          featureFlagGuard(Features.ARTICLE, true, '/#/content/:id'),
        ],
       canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArticleContentRoutingModule {}
